var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.editGroup
      ? _c("div", [
          _c("table", { staticClass: "table table-sm table-hover mt-1" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.editGroup.data, function (r) {
                return !r.to_delete
                  ? _c(
                      "tr",
                      [
                        _c(
                          "td",
                          [
                            _c("multiselect", {
                              attrs: {
                                disabled: !!_vm.editGroup.id,
                                placeholder: "Выберите группу",
                                label: "id",
                                "track-by": "id",
                                options: _vm.allGroups,
                                "option-height": 104,
                                "show-labels": false,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "singleLabel",
                                    fn: function (props) {
                                      return [
                                        _c(
                                          "span",
                                          { staticClass: "option__desc" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "option__title" },
                                              [
                                                _vm._v(
                                                  _vm._s(props.option.title) +
                                                    " (" +
                                                    _vm._s(props.option.id) +
                                                    ")"
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "option",
                                    fn: function (props) {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "option__desc" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "option__title" },
                                              [
                                                _vm._v(
                                                  _vm._s(props.option.title)
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "mt-1" },
                                          [
                                            props.option.data?.projects
                                              ? [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "text-muted",
                                                    },
                                                    _vm._l(
                                                      props.option.data
                                                        .projects,
                                                      function (p, i) {
                                                        return _c("span", [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                i !== 0
                                                                  ? ", "
                                                                  : ""
                                                              ) +
                                                              _vm._s(
                                                                _vm
                                                                  .$AllProjects[
                                                                  p
                                                                ]?.title
                                                              ) +
                                                              "\n                  "
                                                          ),
                                                        ])
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]
                                              : [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "text-muted",
                                                    },
                                                    [_vm._v("Все проекты")]
                                                  ),
                                                ],
                                          ],
                                          2
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                              model: {
                                value: r.group,
                                callback: function ($$v) {
                                  _vm.$set(r, "group", $$v)
                                },
                                expression: "r.group",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            r?.group?.data?.projects
                              ? [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex flex_gap_10 flex-wrap",
                                    },
                                    _vm._l(r.group.data.projects, function (p) {
                                      return _c(
                                        "span",
                                        { staticClass: "badge badge-info" },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.$AllProjects[p]?.title
                                              ) +
                                              "\n            "
                                          ),
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                ]
                              : [
                                  _vm._v(
                                    "\n            Все проекты\n          "
                                  ),
                                ],
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _vm._l([1, 2], function (i) {
                          return [
                            _c(
                              "td",
                              [
                                _vm.allUsers
                                  ? [
                                      _c("multiselect", {
                                        attrs: {
                                          options: _vm.allUsers,
                                          multiple: true,
                                          disabled: !!_vm.editGroup.id,
                                          label: "name",
                                          "track-by": "name",
                                          placeholder: "Выберите пользователя",
                                          "select-label": "Выбрать",
                                          "deselect-label":
                                            "Убрать пользователя",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "singleLabel",
                                              fn: function (props) {
                                                return [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        props.option.name
                                                      ) +
                                                      "\n                  (" +
                                                      _vm._s(
                                                        props.option?.role
                                                          ? props.option.role
                                                          : props.option.roles.find(
                                                              (r) =>
                                                                r.name ===
                                                                "manager"
                                                            )
                                                          ? "М"
                                                          : "П"
                                                      ) +
                                                      ")\n                "
                                                  ),
                                                ]
                                              },
                                            },
                                            {
                                              key: "option",
                                              fn: function (props) {
                                                return [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        props.option.name
                                                      ) +
                                                      "\n                  (" +
                                                      _vm._s(
                                                        props.option?.role
                                                          ? props.option.role
                                                          : props.option.roles.find(
                                                              (r) =>
                                                                r.name ===
                                                                "manager"
                                                            )
                                                          ? "М"
                                                          : "П"
                                                      ) +
                                                      ")\n                "
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                        model: {
                                          value: r.users[`shift_${i}`],
                                          callback: function ($$v) {
                                            _vm.$set(r.users, `shift_${i}`, $$v)
                                          },
                                          expression: "r.users[`shift_${i}`]",
                                        },
                                      }),
                                    ]
                                  : [
                                      _c(
                                        "div",
                                        _vm._l(
                                          r.users[`shift_${i}`],
                                          function (u) {
                                            return _c("p", [
                                              _vm._v(
                                                "\n                  (" +
                                                  _vm._s(u.id) +
                                                  ") " +
                                                  _vm._s(u.name) +
                                                  " (" +
                                                  _vm._s(
                                                    u.role === "manager"
                                                      ? "менеджер"
                                                      : "помощник"
                                                  ) +
                                                  ")\n                "
                                              ),
                                            ])
                                          }
                                        ),
                                        0
                                      ),
                                    ],
                              ],
                              2
                            ),
                          ]
                        }),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: r.schedule,
                                  expression: "r.schedule",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { disabled: !!_vm.editGroup.id },
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    r,
                                    "schedule",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                              },
                            },
                            [
                              _c(
                                "option",
                                { attrs: { value: "0", disabled: "" } },
                                [_vm._v("Выберите график")]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.schedule, function (s) {
                                return _c(
                                  "option",
                                  { domProps: { value: s.id } },
                                  [
                                    _vm._v(
                                      _vm._s(s.start) +
                                        " - " +
                                        _vm._s(s.end) +
                                        " " +
                                        _vm._s(s.title)
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          !_vm.editGroup.id
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn btn-outline-danger",
                                  on: {
                                    click: function ($event) {
                                      r.to_delete = true
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "icon-fa icon-fa-remove",
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ],
                      2
                    )
                  : _vm._e()
              }),
              0
            ),
          ]),
          _vm._v(" "),
          !_vm.editGroup.id
            ? _c(
                "div",
                { staticClass: "text-right" },
                [
                  _c("LoadingButton", {
                    attrs: {
                      title: "Сохранить",
                      type: "button",
                      loading: _vm.loading,
                      onClick: () => _vm.saveGroup(),
                      color: _vm.$constants.SUCCESS_COLOR,
                      className: "btn btn-outline-success",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Группа")]),
        _vm._v(" "),
        _c("th", [_vm._v("проекты")]),
        _vm._v(" "),
        _c("th", [_vm._v("смена 1")]),
        _vm._v(" "),
        _c("th", [_vm._v("смена 2")]),
        _vm._v(" "),
        _c("th", [_vm._v("график")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }